/**
 * Add Notes modal
 * Created On:
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

//  Motif controls
import MotifModal, { MotifModalHeader, MotifModalBody, MotifModalFooter } from '@ey-xd/motif-react/Modal';
import MotifButton, { MotifIconButton } from '@ey-xd/motif-react/Button';
import MotifFormField from '@ey-xd/motif-react/FormField';
import { MotifInput, MotifErrorMessage, MotifLabel } from '@ey-xd/motif-react';
import MotifTooltip from '@ey-xd/motif-react/Tooltip';
import MotifTable from '@ey-xd/motif-react/Table';
import MotifToast from '@ey-xd/motif-react/Toast';

//  Icons imports
import iconAddWhite from '../../../../assets/images/add-circle-white.svg'
import iconArrowBack from '../../../../assets/images/arrow_back.svg';
import iconEmptyNotes from '../../../../assets/images/iconEmptyNotes.svg';
import icon_addition from '../../../../assets/images/icon_addition.svg';
import trash from '../../../../assets/images/trash.svg';
import iconError from '../../../../assets/images/error.svg';
import iconWhiteCheckCircle from "../../../../assets/images/white-check-circle.svg";
import iconSuccess from "../../../../assets/images/check-circle.svg";
import warningCircle from '../../../../assets/images/warning-circle.svg';

//  Redux imports
import { dismissToast } from '../../../../redux/toastSlice';

//  Internal imports
import './Notes.scss';
import DeleteNotesConfirmModal from '../deleteNotesConfirmModal/DeleteNotesConfirmModal';
import TableService from '../../../../services/tableService';

const Notes = ({
    openModal,
    setOpenModal,
    selectedTable,
    tables
}) => {


    const [selectedRange, setSelectedRange] = useState("");
    const [isErrorOnRange, setIsErrorOnRange] = useState(false);
    const [isErrorOnRangeSheet, setIsErrorOnRangeSheet] = useState(false);
    const [selectedRangeData, setSelectedRangeData] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [showClose, setShowClose] = useState(true);
    const [showModal, setShowmodal] = useState(false);
    const [selectedLowervalue, setSelectedLowervalue] = useState();
    const [selectedHighervalue, setSelectedHighervalue] = useState();
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [notesData, setNotesData] = useState([]);
    const [selectedClosebtn, setSelectedClosebtn] = useState(false);
    const [noteToDelete, setNoteToDelete] = useState(null);
    const [individualAddresses, setIndividualAddresses] = useState([]);
 const [showEditToast, setShowEditToast] = useState(false);
    const [individualNotes, setIndividualNotes] = useState([]);
    const tableColumnValues = selectedTable.metadata.uploadRange;
    const [lower1, upper1] = extractNumbers(tableColumnValues);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const { user } = useSelector(state => state.user);
    const {  toastVariant } = useSelector((state) => state.toast);
    const dispatch=useDispatch();
    const lowerValueTableRange = lower1 + 1;
    const tableService = new TableService();

    useEffect(() => {
        if (tables.length > 0) {
            getNotes();

        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (notesData.length > 0) {
            setCurrentStep(2);
            setSelectedClosebtn(false);
        }
    }, [notesData]);

    useEffect(() => {
        if (selectedRangeData) {
            const extractedData = selectedTable.tableContent.slice(
                selectedLowervalue - lowerValueTableRange,
                selectedHighervalue - lowerValueTableRange + 1
            ).map(item => item.rowId);
            setSelectedRowIds(extractedData);
        }
    }, [selectedRangeData, selectedLowervalue,lowerValueTableRange, selectedHighervalue, selectedTable.tableContent]);

    function extractNumbers(address) {
        return address.match(/\d+/g).map(Number);
    }


    const getSelectedRange = () => {
        if (window.Excel) {
            window.Excel.run(async (context) => {
                const selectedRange = context.workbook.getSelectedRange();
                selectedRange.load(["values", "address", "worksheet/name"]);
                await context.sync();
    
                const values = selectedRange.values;
                validateSelectedRange(values);
                if (selectedRange?.address) {
                    const address = selectedRange.address;
                    const vRange = selectedRange.address
                        .replace(selectedRange.worksheet.name, "")
                        .replace(/[&#,+()$~%.'"*?!<>{}]/g, "");
                    const sheetName = selectedRange.worksheet.name;
    
                    function extractNumbers(vAddress) {
                        return vAddress.match(/\d+/g).map(Number);
                    }
    
                    let [lower2, upper2] = extractNumbers(vRange);
                    if (upper2 === undefined) {
                        upper2 = lower2;
                    }
    
                    if (sheetName !== selectedTable.metadata.sheetName) {
                        setIsErrorOnRangeSheet(true);
                        setIsErrorOnRange(false);
                    } else if (lower2 >= lowerValueTableRange && upper2 <= upper1) {
                        let vSelectedValues;
                        if (values && values.length > 0) {
                            vSelectedValues = values.reduce((prev, next) => next.map((item, i) => (prev[i] || []).concat(next[i])), []);
                        }
                        vSelectedValues = vSelectedValues.flat(1);
                        setIndividualNotes(vSelectedValues);
                        const workbook = context.workbook;
                        workbook.load("name");
                        await context.sync();
                        const workbookName = workbook.name;
    
                        const individualAddresses = [];
                        const rangeParts = address.split('!');
                        if (rangeParts.length > 1) {
                            const range = rangeParts[1];
                            const [startCell, endCell] = range.split(':');
                            const startRow = parseInt(startCell.match(/\d+/)[0]);
                            const endRow = endCell ? parseInt(endCell.match(/\d+/)[0]) : startRow; // Handle single cell selection
                            const column = startCell.match(/[A-Z]+/)[0];
    
                            for (let i = startRow; i <= endRow; i++) {
                                individualAddresses.push(`${sheetName}!${column}${i}`);
                            }
                            setIndividualAddresses(individualAddresses);
                            setSelectedRange(address);
                        } else {
                            console.error("Invalid address format");
                        }
                        const result = {
                            notes_data: vSelectedValues,
                            notes_metadata: {
                                filename: workbookName,
                                sheetName: sheetName,
                                uploadRange: address,
                                lower2: lower2,
                                upper2: upper2,
                            }
                        };
    
                        if (result) {
                            setSelectedRangeData(result);
                            setSelectedLowervalue(lower2);
                            setSelectedHighervalue(upper2);
                            setIsErrorOnRangeSheet(false);
                        }
                    } else {
                        setIsErrorOnRange(true);
                        setIsErrorOnRangeSheet(false);
                    }
                } else {
                    setIsErrorOnRange(true);
                    setIsErrorOnRangeSheet(false);
                }
            }).catch((error) => {
                console.error("Error: " + error);
            });
        }
    };
    
    const validateSelectedRange = (vRange) => {
        if (vRange.length > 0) {
            setIsErrorOnRange(false);
            setIsErrorOnRangeSheet(false);
        } else {
            setIsErrorOnRange(true);
            setIsErrorOnRangeSheet(false);
            return;
        }
    
        const flattenedRange = vRange.flat(1);
        const allEmptyStrings = flattenedRange.every(item => item === "");
    
        if (allEmptyStrings) {
            setIsErrorOnRange(true);
            setIsErrorOnRangeSheet(false);
            return;
        }
    
        const isValid = vRange.every(innerArray => innerArray.length === 1);
        setIsErrorOnRange(!isValid);
        setIsErrorOnRangeSheet(false);
    };
    

    /**
      * This assists in configuring column headers.
      */
    const colDefs = [
        {
            headerName: "Line",
            field: "RowHeader",
            wrapText: true,
            autoHeight: true,
            flex: 5,
            minWidth: 150,
            maxWidth: 1200,
            cellClass: 'relation-column',
            filter: false,
            sortable: false,
            headerClass: 'ag-column-first'
            
        },
        {
            headerName: "Notes Cell",
            field: "notes_range",
            wrapText: true,
            autoHeight: true,
            flex: 1,
            minWidth: 135,
            maxWidth: 135,
            type: 'centerAligned',
            cellClass: 'relation-column',
            filter: false,
            sortable: false
        },
        {
            field: "",
            headerName: "Actions",
            wrapText: true,
            flex: 1,
            minWidth: 105,
            maxWidth: 120,
            autoHeight: true,
            cellRenderer: (params) => {
                return (
                    <MotifIconButton
                        aria-label="Delete"
                        className="btnDelete"
                        onClick={() => {
                            setNoteToDelete(params.data.rowId);
                            handleOpenModal()
                        }}
                    >
                        <img className='trashrelation' src={trash} alt="Delete" />
                    </MotifIconButton>
                );
            },
            cellClass: 'relation-column-center',
            colId: "actions",
            filter: false,
            sortable: false
        }
    ];

    const addNotes = async () => {
        const userId = user.username;
        const ids = individualNotes
        .map((note, index) => ({
            notes: note,
            rowId: selectedRowIds[index],
            notes_range: individualAddresses[index]
        }))
        .filter((note, index) => {
            const isRowBank = selectedTable?.tableContent?.findIndex(row => (
                (row?.rowId === selectedRowIds[index]) && (row?.IsBlank !== true))
            );
            return (isRowBank !== -1);
        });

        const vData = {
            ids: ids,
            tableId: selectedTable.id,
            userId: userId

        };

        try {
            const response = await tableService.addNotes(vData);
            if (response) {
               await getNotes();
                setCurrentStep(2);
                setShowEditToast(true);
                setSelectedClosebtn(false);
            } else {
                throw new Error(response?.output || 'Unknown error');
            }
        } catch (error) {
            console.error("Error adding notes:", error);
            setShowErrorPopup(true);
            console.error("Error details:", error.response ? error.response.data : error.message);
             dispatch(dismissToast());
        }
    };
    const getNotes = async () => {

        const requestData = {
            tableId: selectedTable.id
        };

        try {
            const response = await tableService.getNotes(requestData);
            if (response) {
                const processedNotesData = loadExistingNotesData(response);
                setNotesData(processedNotesData);
            } else {
                throw new Error(response?.output || 'Unknown error');
            }
        } catch (error) {
            console.error("Error fetching notes:", error);
        }
    };
    const loadExistingNotesData = (notesData) => {
        if (notesData) {
            return notesData
                .filter(note => note.notes && note.RowHeader !== "") 
                .map(note => ({
                    RowHeader: note.RowHeader,
                    notes_range: note.range,
                    rowId: note.rowId
                }));
        }

        return [];
    };
    const handleDelete = async () => {
        const userId = user.username;
        const requestData = {
            ids: noteToDelete,
            tableId: selectedTable.id,
            userId: userId

        };
        try {
            const response = await tableService.deleteNotes(requestData);
            if (response ) {
                const updatedData = notesData.filter(note => note.rowId !== noteToDelete);
                setNotesData(updatedData);
                setShowmodal(false);
                setShowErrorPopup(false); 
                if (updatedData.length === 0) {
                    setShowToast(true);
                    setCurrentStep(1); 
                    setSelectedClosebtn(false); 
                } else {
                    setShowToast(true);
                }
                getNotes();
            } else {
                throw new Error('Delete operation failed');
            }
        } catch (error) {
            setShowmodal(false);
            setShowErrorPopup(true);
            dispatch(dismissToast());
        }
    };
    /**
     * Function to open a Delete_notes modal.
     */

    const handleOpenModal = () => {
        setShowmodal(true);
    };

    /**
      * Function to close a Delete_notes modal.
      */

    const handleCloseModal = () => {
        setNoteToDelete(null);
        setShowmodal(false);
    }
    const closeErrorPopup = () => {
        setShowErrorPopup(false);
    };
    return (
        <>
            {showModal && (
                <DeleteNotesConfirmModal
                    onClose={handleCloseModal}
                    handleDelete={handleDelete}
                />
            )}
            <MotifModal
                show={openModal}
                onClose={() => setOpenModal(!openModal)}
                focusTrapOptions={{
                    tabbableOptions: {
                        displayCheck: "none",
                    },
                }}
                className='TableRelationshipModal genericModal modalMotifFooterModal'
                size='xl'
            >
                <MotifModalHeader
                    closeButtonProps={{
                        'aria-label': 'Close',
                        title: 'Close'
                    }}
                     className={currentStep === 1? 'addEmptyNoteHeaer':'addTableRelationshipHeader'}           
                >
                    <div className='addTableRelationshipHead'>
                        {(currentStep === 1 || (currentStep === 2 && selectedClosebtn === false))
                            ? `Notes for ${selectedTable.tableName}`
                            : `Add Notes for ${selectedTable.tableName}`}
                    </div>
                </MotifModalHeader>
                <MotifModalBody className='modalbodyforrelationship'>
                    {currentStep === 1 && notesData.length === 0 && showEditToast === false && (
                        <div className='bodycenterdivrelation'>
                            <div className='bodycenterinnerdiv'>
                                <img src={iconEmptyNotes} alt="No Notes" />
                            </div>
                            <div className='bodycenterinnerdivtext'>
                                Notes not added
                            </div>
                            <div className='bodycenterinnerdivbottomtext'>
                                <p className='addnotestext'>Click <mark className='addrelation'> ‘Add Notes’ </mark> to select range</p>
                                <div className='tableRelationshipNoRelation'>
                                    <MotifIconButton
                                        className='add-relationship-btn'
                                        aria-label="Click here to add notes"
                                        onClick={() => {
                                            setSelectedRange("");
                                            setCurrentStep(2);
                                            setSelectedClosebtn(true);
                                            setShowClose(false);
                                        }}
                                        data-testid="testIdBtnBack"
                                    >
                                        <img className='addrelationicon' src={icon_addition} alt="Add Notes" />
                                        <p className='add-relation-rel'>Add Notes</p>
                                    </MotifIconButton>
                                </div>
                            </div>
                        </div>
                    )}
                    {currentStep === 2 && notesData.length > 0 && selectedClosebtn === false && (
                        <MotifTable
                            rowData={notesData}
                            columnDefs={colDefs}
                            suppressCellFocus
                            suppressRowClickSelection
                            suppressRowHoverHighlight
                            enableSorting={false}
                            className='tablenotes'
                        />
                    )}
                    {currentStep === 2 && notesData.length >= 0 && selectedClosebtn === true &&
                        (
                            <>
                                {/* <div className='descriptionnote'>
                                    Notes added for this table will be used in generating Line Analysis and Table Analysis
                                </div> */}
                                <div className="lblSelectRange rangefield">
                                    Select Range
                                </div>
                                <div className='fldRange'>
                                <MotifFormField className={(isErrorOnRange || isErrorOnRangeSheet) ? 'field-group error-border' : 'field-group'}>
            <MotifInput
                onChange={(e) => setSelectedRange(e.target.value)}
                value={selectedRange}
                placeholder='Add range'
                onFocus={() => getSelectedRange()}
                className={(isErrorOnRange || isErrorOnRangeSheet) ? 'inputThreshold motif-input-invalid' : 'inputThreshold'}
                data-testid="testIdFldRange"
                readOnly={true}
            />
            {(isErrorOnRange || isErrorOnRangeSheet) && (
                <MotifTooltip
                    contentClassName="tooltipWithoutCloseCenterText"
                    trigger={
                        <img src={iconError} alt='Error' className='helpTooltipIcon' />
                    }
                    placement='top'
                    allowClick={false}
                    hideCloseButton={true}
                    hide={true}
                >
                    Please select a <br />valid range
                </MotifTooltip>
            )}
        </MotifFormField>
                                    {isErrorOnRangeSheet && (
            <MotifLabel className='rangeMessage errorText'>
                Selection must be from the same table
            </MotifLabel>
        )}
        {isErrorOnRange && (
            <MotifErrorMessage className='rangeMessage errorText'>
                Selected range must be aligned with table range
            </MotifErrorMessage>
        )}
                                </div>
                            </>
                        )
                    }
             {currentStep === 2 && showErrorPopup && (
                          <div className="errorToastMesg">
                          <MotifToast
                            actionName=""
                            icons={{ toast: <img src={warningCircle} alt="Search" /> }}
                            onClose={() => closeErrorPopup()}
                            variant={toastVariant}
                            className="errorToast"
                          >
                            <div>
                              <span className="errorToast-heading">
                                System error <br />
                              </span>
                              <span className="errorToast-description">
                                Please try again later. If the issue persists, please contact
                                support@ey.com
                              </span>
                            </div>
                          </MotifToast>
                        </div>
                  )}
                </MotifModalBody>
                <MotifModalFooter className='TableRelationshipFooter'>
                    <div className='tableRelationshipToastLayer'>
                                            {showToast && (
                                                <MotifToast
                                                    actionName=""
                                                    onClose={() => {
                                                        setShowToast(false);
                                                    }}
                                                    variant="info"
                                                    className='notifyToast11'
                                                    icons={{toast: <img src={iconWhiteCheckCircle} alt="Info" />}}
                                                >
                                                    Notes removed
                                                </MotifToast>
                                            )}
                                            {(showEditToast) &&
                                                <MotifToast
                                                    actionName=""
                                                    onClose={() => {
                                                        setShowEditToast(false);
                                                    }}
                                                    variant={"success"}
                                                    className='notifyToast'
                                                    icons={{ toast: <img src={iconSuccess} alt="Success" /> }}
                                                >
                                                    Notes added successfully
                                                </MotifToast>
                                            }
                                          {(currentStep === 1) && showErrorPopup && (
                                              <div className="errorToastMesg">
                                                      <MotifToast
                                                        actionName=""
                                                        icons={{ toast: <img src={warningCircle} alt="Search" /> }}
                                                        onClose={() => closeErrorPopup()}
                                                        variant={toastVariant}
                                                        className="errorToast"
                                                      >
                                                        <div>
                                                          <span className="errorToast-heading">
                                                            System error <br />
                                                          </span>
                                                          <span className="errorToast-description">
                                                            Please try again later. If the issue persists, please contact
                                                            support@ey.com
                                                          </span>
                                                        </div>
                                                      </MotifToast>
                                                    </div>
                                      )}
                                        </div>
                    <div className='tableRelationshipFooterleftkpi'>
                        {currentStep === 2 && notesData.length > 0 && selectedClosebtn === false && (
                            <MotifIconButton
                                className='add-relationshipkpi'
                                onClick={() => {
                                    setCurrentStep(2);
                                    setSelectedClosebtn(true);
                                    setShowClose(false);

                                }}
                            >
                                <img className='addrelationicon' src={iconAddWhite} alt="Add Notes" />
                                <p className='add-relationkpi'>Add Notes</p>
                            </MotifIconButton>
                        )}
                    </div>
                    <div className='tableRelationshipFooterleftkpiback'>
                        {currentStep === 2 && selectedClosebtn === true && (
                            <MotifButton
                                aria-label="Click here to go back to 'Notes' popover"
                                onClick={() => {
                                      setSelectedRange("");
                                    if (notesData.length > 0) {
                                        setCurrentStep(2);
                                    } else {
                                        setCurrentStep(1);
                                    }
                                    setSelectedClosebtn(false);
                                    setShowClose(false);
                                }}
                                className='btnBackKPI'
                                data-testid="testIdBtnBack"
                                variant='text'
                            >
                                <img src={iconArrowBack} alt='Back' />
                                <span className='back-arrow'>Back</span>
                            </MotifButton>
                        )}
                    </div>
                    <div className='tableRelationshipFooterRight'>
                    {currentStep === 1 && notesData.length === 0 && showEditToast === false &&(
                        <MotifButton
                        onClick={() => {
                            setOpenModal(!openModal)
                            setSelectedClosebtn(false)
                        }
                        }
                        type="button"
                        variant="secondary"
                        className='btnCancel'
                    >
                        Close
                    </MotifButton> 
                    )}
                        {currentStep === 2 && notesData.length > 0 && selectedClosebtn === false  && (
                            <MotifButton
                                onClick={() => {
                                    setOpenModal(!openModal)
                                    setSelectedClosebtn(false)
                                }
                                }
                                type="button"
                                variant="secondary"
                                className='btnCancel'
                            >
                                Close
                            </MotifButton>
                        )}
                        {currentStep === 2 && selectedClosebtn === true && showClose === false && (
                            <MotifButton
                            onClick={() => {
                                setOpenModal(!openModal)
                                setSelectedClosebtn(false)
                            }}
                                type="button"
                                variant="secondary"
                                className='btnCancel'
                            >
                                Cancel
                            </MotifButton>
                        )}
                        {currentStep === 2 && selectedClosebtn === true && (
                            <MotifButton
                                onClick={() => {
                                    addNotes();
                                    setCurrentStep(2);
                                    setSelectedClosebtn(false);
                                }}
                                type="button"
                                className='btnConfirm'
                                disabled={!selectedRangeData || isErrorOnRange||isErrorOnRangeSheet}
                            >
                                Confirm
                            </MotifButton>
                        )}
                    </div>
                </MotifModalFooter>
            </MotifModal>
        </>
    );

}
export default Notes;